const ActionTypes = {
  REGISTER_REQUEST: 'REGISTER_REQUEST',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAIL: 'REGISTER_FAIL',

  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAIL: 'LOGOUT_FAIL',

  USER_UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
  USER_UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
  USER_UPDATE_FAIL: 'USER_UPDATE_FAIL',

  USER_UPDATE_IMG_REQUEST: 'USER_UPDATE_IMG_REQUEST',
  USER_UPDATE_IMG_SUCCESS: 'USER_UPDATE_IMG_SUCCESS',
  USER_UPDATE_IMG_FAIL: 'USER_UPDATE_IMG_FAIL',

  UPLOAD_PROFILE_IMG_REQUEST: 'UPLOAD_PROFILE_IMG_REQUEST',
  UPLOAD_PROFILE_IMG_SUCCESS: 'UPLOAD_PROFILE_IMG_SUCCESS',
  UPLOAD_PROFILE_IMG_FAIL: 'UPLOAD_PROFILE_IMG_FAIL',

  GET_WORKOUTS_REQUEST: 'GET_WORKOUTS_REQUEST',
  GET_WORKOUTS_SUCCESS: 'GET_WORKOUTS_SUCCESS',
  GET_WORKOUTS_FAIL: 'GET_WORKOUTS_FAIL',

  GET_WORKOUT_REQUEST: 'GET_WORKOUT_REQUEST',
  GET_WORKOUT_SUCCESS: 'GET_WORKOUT_SUCCESS',
  GET_WORKOUT_FAIL: 'GET_WORKOUT_FAIL',

  GET_EXERCISES_REQUEST: 'GET_EXERCISES_REQUEST',
  GET_EXERCISES_SUCCESS: 'GET_EXERCISES_SUCCESS',
  GET_EXERCISES_FAIL: 'GET_EXERCISES_FAIL',

  RESET_STATUS: 'RESET_STATUS',
};

export default ActionTypes;
